import { AppointmentCalendarIntegrationsRequest, Page } from 'types'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'
import { AppointmentCalendarIntegration } from 'types/appointmentCalendarIntegration'
import { applySearchParams, urlToPathnameAndSearch } from '../utils'

const pathname = `/api/${apiVersion}/appointments/calendar-integrations`

const makeGetAppointmentCalendarIntegrations =
  (baseUrl: string, config: HttpClientConfig) =>
  async (request: AppointmentCalendarIntegrationsRequest): Promise<AppointmentCalendarIntegration[]> => {
    const url = new URL(pathname, baseUrl)
    applySearchParams(url, { appointment_gid: request.appointmentGid })
    const pathnameAndSearch = urlToPathnameAndSearch(url)

    const { data } = await service(baseUrl).get<Page<AppointmentCalendarIntegration>>(pathnameAndSearch, config)

    return data.data
  }

export { makeGetAppointmentCalendarIntegrations }
